import { Navigate } from "react-router-dom";

export const PrivateRoute = ({ children, isActive, redirect }) => {
  return isActive ? children :  <Navigate to={redirect} />;
}